import React, { useEffect, useState } from 'react';
import './sidebar.css';
import sidebarImg from './BlueSidebar2.png';
import buttonImg from '../button1.png';

const buttonConfigs = [
    { label: 'Home' },
    { label: 'Play Game' },
    { label: 'Account' },
    { label: 'Hanger' },
    { label: 'Log Out' },
];

const Sidebar = ({ activePage, setActivePage, onPlayGame, onLogout }) => {
    const [utcTime, setUtcTime] = useState('');

    useEffect(() => {
        const updateTime = () => {
            const now = new Date();
            const hh = String(now.getUTCHours()).padStart(2, '0');
            const mm = String(now.getUTCMinutes()).padStart(2, '0');
            const ss = String(now.getUTCSeconds()).padStart(2, '0');
            setUtcTime(`${hh}:${mm}:${ss}`);
        };
        updateTime();
        const interval = setInterval(updateTime, 1000);
        return () => clearInterval(interval);
    }, []);

    return (
        <div className="sidebar">
            <img src={sidebarImg} alt="Sidebar background" className="sidebar-bg" />

            {/* Plate behind buttons */}
            <div className="sidebar-button-plate"></div>

            {/* UTC time plate */}
            <div className="sidebar-utc-plate">
                <span className="utc-text">UTC: {utcTime}</span>
            </div>

            <div className="sidebar-buttons">
                {buttonConfigs.map(({ label }) => (
                    <button
                        key={label}
                        className={`sidebar-button ${activePage === label ? 'active' : ''}`}
                        onClick={() => {
                            if (label === 'Play Game') {
                                setActivePage('');
                                onPlayGame();
                                return;
                            }
                            if (label === 'Account') {
                                setActivePage('Account');
                                return;
                            }
                            if (label === 'Log Out') return onLogout();
                            setActivePage(label);
                        }}
                    >
                        <img src={buttonImg} alt={`${label} icon`} />
                        <span className="sidebar-label">{label}</span>
                    </button>
                ))}
            </div>
        </div>
    );
};

export default Sidebar;
